export default __webpack_public_path__ + "static/media/151-flats.914b364b.png";